import * as _ from 'lodash';
import { ICenterBase, IListItem } from '@nkr/models/index';
import { FormEvent } from 'react';
import { FormControl, Well } from 'react-bootstrap';

interface IProps {
    incidentStatusId: number,
    centerId: number,
    incidentCategoryTypeId: number,
    incidentOriginTypeId: number,
    startDate: string,
    endDate: string,
    search: string,
    incidentStatusList: IListItem[],
    incidentCategoryTypeList: IListItem[],
    incidentOriginTypeList: IListItem[],
    memberCenters: ICenterBase[],
    onStatusChange: (statusId: number) => void,
    onCenterChange: (centerId: number) => void,
    onCategoryTypeChange: (categoryTypeId: number) => void,
    onOriginTypeChange: (originTypeId: number) => void,
    onStartDateChange: (startDate: string) => void,
    onEndDateChange: (endDate: string) => void,
    onSearchChange: (search: string) => void
}

const IncidentListSearch = (props: IProps) => {
    const handleStatusChange = (e: FormEvent<FormControl & HTMLSelectElement>) => {
        props.onStatusChange(parseInt(e.currentTarget.value));
    };

    const handleCenterChange = (e: FormEvent<FormControl & HTMLSelectElement>) => {
        props.onCenterChange(parseInt(e.currentTarget.value));
    };

    const handleCategoryTypeChange = (e: FormEvent<FormControl & HTMLSelectElement>) => {
        props.onCategoryTypeChange(parseInt(e.currentTarget.value));
    };

    const handleOriginTypeChange = (e: FormEvent<FormControl & HTMLSelectElement>) => {
        props.onOriginTypeChange(parseInt(e.currentTarget.value));
    };

    const handleSearchChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        props.onSearchChange(e.currentTarget.value);
    };

    const handleStartDateChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        props.onStartDateChange(e.currentTarget.value);
    };

    const handleEndDateChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        props.onEndDateChange(e.currentTarget.value);
    };

    const memberCenters = _.sortBy(props.memberCenters, x => x.alias);

    return (
        <Well bsSize='sm' style={{ display: 'flex', alignItems: 'center', marginBottom: 5 }}>
            <div style={{ display: 'flex', alignItems: 'center', marginRight: 30 }}>
                <div style={{ marginRight: 5 }}>Status:</div>
                <FormControl
                    componentClass='select'
                    value={props.incidentStatusId}
                    onChange={handleStatusChange}
                >
                    <option value={0}>- ALL STATUS TYPES -</option>
                    {props.incidentStatusList.map((incident, index) =>
                        <option key={index} value={incident.id}>{incident.description}</option>
                    )}
                </FormControl>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', marginRight: 30 }}>
                <div style={{ marginRight: 5 }}>Center:</div>
                <FormControl
                    componentClass='select'
                    value={props.centerId}
                    onChange={handleCenterChange}
                >
                    <option value={0}>- ALL CENTERS -</option>
                    {memberCenters.map((center, index) =>
                        <option key={index} value={center.id}>{center.alias}</option>
                    )}
                </FormControl>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', marginRight: 30 }}>
                <div style={{ marginRight: 5 }}>Category:</div>
                <FormControl
                    componentClass='select'
                    value={props.incidentCategoryTypeId}
                    onChange={handleCategoryTypeChange}
                >
                    <option value={0}>- ALL CATEGORY TYPES -</option>
                    {props.incidentCategoryTypeList.map((incident, index) =>
                        <option key={index} value={incident.id}>{incident.description}</option>
                    )}
                </FormControl>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', marginRight: 30 }}>
                <div style={{ marginRight: 5 }}>Origin:</div>
                <FormControl
                    componentClass='select'
                    value={props.incidentOriginTypeId}
                    onChange={handleOriginTypeChange}
                >
                    <option value={0}>- ALL ORIGIN TYPES -</option>
                    {props.incidentOriginTypeList.map((incident, index) =>
                        <option key={index} value={incident.id}>{incident.description}</option>
                    )}
                </FormControl>
            </div>


            <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                <div style={{ marginRight: 5 }}>Start Date:&nbsp;</div>
                <div>
                    <FormControl
                        type='date'
                        name='startDate'
                        value={props.startDate}
                        onChange={handleStartDateChange}
                    />
                </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                <div style={{ marginRight: 5 }}>End Date:</div>
                <div>
                    <FormControl
                        type='date'
                        name='endDate'
                        value={props.endDate}
                        onChange={handleEndDateChange}
                    />
                </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div style={{ marginRight: 5 }}>Search:</div>
                <FormControl
                    value={props.search}
                    placeholder='Search across all fields...'
                    onChange={handleSearchChange}
                />
            </div>
        </Well>
    );
}

export default IncidentListSearch;